<template>
	<div>
		<el-upload ref="shangtu" :headers="headers" class="shangtu" :file-list="shu" :action="url" :on-exceed="Shuliangchaochu" :on-success="Shangchuangchenggong"
		 list-type="picture-card" :limit="Number(shuliang)" :multiple="Number(shuliang)>1">
			<i class="el-icon-plus"></i>
			<div slot="file" slot-scope="{file}">
				<el-progress type="circle" :percentage="parseInt(file.percentage)" :width="50" v-if="file.percentage<100"></el-progress>
				<img class="el-upload-list__item-thumbnail" :src="file.url" v-else />
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="Yulan(file)"> <i class="el-icon-zoom-in"></i></span>
					<span class="el-upload-list__item-delete" @click="Shanchu(file)"><i class="el-icon-delete"></i></span>
				</span>
			</div>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl">
		</el-dialog>
	</div>
</template> 

<script>
	export default {
		data() {
			return {
				shu: [],
				url: '',
				dialogImageUrl: '',
				dialogVisible: false,
				a: [],
				headers:{}
			};
		},
		props: {
			shuliang: {
				type: [Number, String],
				default: 1
			},
			value: {
				type: [Array, String],
			}
		},
		created() {
			var that = this;
			this.url = this.$url + "&k=wenjian";
			setTimeout(function() {				
				if (typeof that.value == "string") {
					that.shu = [{
						url: that.value
					}];
					that.a.push(that.value);
				} else if (typeof that.value == 'object') {				
					that.a = that.value;
					for (var i in that.value) {
						that.shu.push({
							url: that.value[i]
						});
					}
				}
			}, 500)
			var yonghu=this.$qu('yonghu') || [];
			this.headers.kouling=yonghu.kouling;
		},
		methods: {
			Shangchuangchenggong(res, file) {
				if (res.shi == 1) {
					this.a.push(res.shu.url);
				} else {
					this.$xiaoxi(res.shu, 0);
				}
				this.Liebiao();
			},
			Shuliangchaochu() {
				this.$xiaoxi('超出上传数量', 0);
			},
			Yulan(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			qingkong(){
				this.$refs.shangtu.clearFiles();
			},
			Shanchu(aa) {
				for (var i in this.$refs.shangtu.uploadFiles) {
					if (this.$refs.shangtu.uploadFiles[i].uid == aa.uid) {
						this.$refs.shangtu.uploadFiles.splice(i, 1);
						this.a.splice(i, 1);
					}
				}
				this.Liebiao();
			},
			Liebiao() {
				this.a=[];
				for(var ii in this.$refs.shangtu.uploadFiles){
					if(this.$refs.shangtu.uploadFiles[ii].response && this.$refs.shangtu.uploadFiles[ii].response.shu){
						this.a.push(this.$refs.shangtu.uploadFiles[ii].response.shu.url);
					}
				}
				if (this.a.length == 1) {
					this.$emit('input', this.a[0]);
				} else {
					this.$emit('input', this.a);
				}
				
			}
		}
	}
</script>

<style>
	.shangtu {
		width: 100%;	
	}

	.shangtu .el-upload--picture-card {
		width: 100px;
		height: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.shangtu .el-upload-list--picture-card {
		display: flex;
	}

	.shangtu .el-upload-list--picture-card .el-upload-list__item {
		width: 100px;
		height: 100px;
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.shangtu .el-upload-list--picture-card .el-progress {
		width: 50px;
	}
</style>
